export default "__VITE_ASSET__D3g6P94v__"